import profileSettingsTooltip from '@/modules/base-module/profile/components/ProfileSettingsTooltip.vue'
import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { isFunction } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          // partner basic details
          {
            component: this.columnsContentComponent,
            title: this.$t('administration/partner.partner_details'),
            showButtons: false,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                images: {
                  keys: [
                    'avatar'
                  ],
                  style: {
                    width: '120px',
                    height: '120px',
                    borderRadius: '70px'
                  },
                  default_image: '/img/default_images/hr/logo.png'
                },
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('administration/partner.name'),
                    placeholder: this.$t('administration/partner.enter_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'categories',
                    label: this.$t('administration/partner_category.category'),
                    placeholder: this.$t('administration/partner.select_category'),
                    persistentPlaceholder: true,
                    type: 'combobox',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partner-categories/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('administration/partner_type.type'),
                    placeholder: this.$t('administration/partner.select_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partner-types/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // partner other details
          {
            component: this.columnsContentComponent,
            title: this.$t('administration/partner.other_details'),
            showButtons: false,
            cardStyle: {
              maxWidth: '880px'
            },
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'main_address',
                    label: this.$t('administration/partner.main_address'),
                    placeholder: this.$t('administration/partner.enter_main_address'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'pin',
                    label: this.$t('administration/partner.pin'),
                    placeholder: this.$t('administration/partner.enter_oib'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'country',
                    label: this.$t('locations.country'),
                    placeholder: this.$t('administration/partner.select_country'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'countries/autocomplete'
                    },
                    onChange: (event) => this.onCountrySelect(event, 'form'),
                    creatable: false,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'city_id',
                    label: this.$t('locations.city'),
                    placeholder: this.$t('administration/partner.select_city'),
                    type: 'autocomplete',
                    items: this.formCitiesData.data,
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('administration/partner.select_country_first')
                      }
                    },
                    autocomplete_options: {
                      module: 'base',
                      route: `countries/${this.formCitiesData.countryId}/cities/autocomplete`,
                      fetchInitial: false,
                      // remove previously set form cities data
                      onDataReceive: () => {
                        this.$set(this.formCitiesData, 'data', [])
                      }
                    },
                    hasMore: this.formCitiesData.hasMore,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'group_id',
                    label: this.$t('administration/partner_group.group'),
                    placeholder: this.$t('administration/partner.select_group'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partner-groups/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'postal_code',
                    label: this.$t('administration/partner.postal_code'),
                    placeholder: this.$t('administration/partner.enter_postal_code'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'geolocation',
                    label: this.$t('administration/partner.geolocation'),
                    placeholder: this.$t('administration/partner.select_location'),
                    append: {
                      src: '/img/icons/select-location-icon.svg'
                    },
                    readonly: true,
                    appendIconClick: (event) => this.showLocationsDialog(event),
                    onClick: (event) => this.showLocationsDialog(event),
                    clearErrorsOnValueChange: true,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    showLocationsDialog (event) {
      const coords = event?.formData?.geolocation?.replace(' ', '').split(',')
      const latitude = coords?.[0] || event?.formData?.geolocation?.lat
      const longitude = coords?.[1] || event?.formData?.geolocation?.lng

      this.$set(this.chooseLocationDialogConfig, 'show', true)
      this.$set(this.chooseLocationDialogConfig, 'title', this.$t('road-maintenance.excavation_modal_location_btn'))
      this.$set(this.chooseLocationDialogConfig, 'event', event)
      if (latitude && longitude) {
        this.$set(this.chooseLocationDialogConfig, 'markers', {
          lat: latitude,
          lng: longitude
        })
      }
      this.$set(this.chooseLocationDialogConfig, 'callback', (event) => this.onLocationSaveCallback(event))
    },

    onLocationSaveCallback (event) {
      const { coordinates } = event || {}
      const { updateData } = registeredTabsHandlers?.[TAB_KEY] || {}

      if (isFunction(updateData)) {
        updateData({
          geolocation: (coordinates?.lat || null) + ', ' + (coordinates?.lng || null)
        })
      }
      this.chooseLocationDialogConfig.show = false
    }
  }
}
